<template>
  <div class="faq-container">
    <h2>Frequently asked Questions</h2>
    <h4>
      If you are hesitating, do not worry - we are here to explain everything
      you might  want to know. Let us help!
    </h4>

    <ExpandText v-for="faq in faqList" :key="faq.question">
      <template v-slot:header>
        {{ faq.question }}
      </template>

      <div v-html="faq.answer"></div>
    </ExpandText>

    <div class="support-container">
      <h2>Have a specific question?</h2>
      <h4>Write to our support team, we will answer all your questions</h4>
      <a href="mailto:support@mahatat.com"
        class="btn btn-blue"
        type="button">
        Contact us
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import ExpandText from './ExpandText.vue';

export default {
  name: 'FaqList',
  components: {
    ExpandText,
  },
  computed: {
    ...mapState('content', ['faqList']),
  },
  created() {
    this.$store.dispatch('content/getFaqList');
  },
};
</script>

<style lang="less" scoped>
  .faq-container {
    margin-top: 120px;
    text-align: center;

    h2 {
      font-size: 2.25rem;
      margin-bottom: 13px;
    }

    h4 {
      font-weight: normal;
      color: #7a7a7a;
      margin-bottom: 63px;
    }

    .support-container {
      text-align: center;
      margin-top: 80px;

      h4 {
        margin-bottom: 30px;
      }
    }
  }

  @media (max-width: 768px) {
    .faq-container {
      margin-top: 48px;
      text-align: left;

      h2 {
        font-size: 1.5rem;
        margin-bottom: 5px;
      }

      h4 {
        margin: 0 0 50px;
      }

      .support-container {
        text-align: center;
        margin-top: 50px;
      }
    }
  }
</style>
